import './stickyHeader.scss';
import { analytics } from './analytics';

export function stickyHeader(){
	function throttle(callback, limit) {
		var wait = false;
		return function() {
			if (wait) return;
			callback.call();
			wait = true;
			setTimeout(function(){
				wait = false;
			}, limit);
		}
	}

	function sticker(){
		let header = document.querySelector(".site-header.not-top"),
			menu = document.getElementById("cue--chapter-nav");

		if (header != null) {
			let box = menu.getBoundingClientRect();

			if (menu.style.top == "") {
				let dimen = header.getBoundingClientRect();

				menu.style.top = `${header.offsetHeight + dimen.top}px`;
			}
		} else {
			if (menu.style.top != "") {
				menu.style.top = "";
			}
		}
	}

	// for mobile expansion, otherwise collapse
	function button(){
		let btn = document.getElementById("cue--nav__mobile"),
			container = document.getElementById("nav__topmenu"),
			chapterTitle = btn.querySelector(".nav__chapter-name"),
			subMenuBtn = document.querySelectorAll(".chevron");

		btn.addEventListener("click", e => {
			e.target.blur();
			let items = container.querySelectorAll("#nav__topmenu > li"),
				height = 0;

			if (btn.classList.contains("mobile__open")) {
				btn.classList.remove("mobile__open");
				container.classList.remove("mobile__open");

				container.style = null;
				btn.style = null;
			} else {
				btn.classList.add("mobile__open");
				container.classList.add("mobile__open");

				btn.style.height = chapterTitle.offsetHeight + btn.offsetHeight + "px";

				items.forEach(y => {
					height = height + y.offsetHeight;
				})

				container.style.minHeight = height + "px";
				setTimeout(() => {
					container.style.height = "auto";
					container.style.paddingBottom = "40px";
				}, 300);
			} 
		});

		subMenuBtn.forEach(x => {
			x.addEventListener("click", e => {
				e.target.blur();
				let menu = x.parentElement.querySelector(".nav__submenu"),
					items = menu.querySelectorAll("li"),
					height = 0;

				if (menu.classList.contains("submenu__open")) {
					menu.classList.remove("submenu__open");
					menu.style = null;
				} else {
					menu.classList.add("submenu__open");

					items.forEach(y => {
						height = height + y.offsetHeight;
					})

					menu.style.height = height + "px";
				}

				x.classList.contains("btn__open") ? x.classList.remove("btn__open") : x.classList.add("btn__open");
			})
		});
	}

	// capture events for analytics
	function navEvents(){
		let menuItems = document.querySelectorAll("#nav__topmenu > li"),
			subMenuItems = document.querySelectorAll(".nav__submenu > li"),
			expand = document.querySelector(".header__download");

		menuItems.forEach(item => {
			let label = item.querySelector("a").innerText;

			label = label.toLowerCase().replace(/\s/gi, "_");

			item.addEventListener("mouseenter", () => {
				analytics("nav_hover", label);
			})
		});

		subMenuItems.forEach(entry => {
			let subLabel = entry.innerText;

			subLabel = subLabel.toLowerCase().replace(/\s|\-/gi,"_").replace(/\?/gi, "");

			entry.addEventListener("click", e => {
				analytics("nav_click", subLabel);
			})
		});

		expand.addEventListener("click", () => {
			analytics("button_click", "explore_strategies");
		})
	}

	button();
	navEvents();

	window.addEventListener("scroll", throttle(sticker, 100));
}
